module.exports = __webpack_public_path__ + "static/img/15.fe7ffce.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/XVC/images/15.png
// module id = T1lf
// module chunks = 4